// Helper function to check if a Date object is valid
export function isValidDate(date: Date): boolean {
    return date && typeof date.getTime === 'function' && !isNaN(date.getTime());
}

export const getValidDate = (date: Date | string | null): Date | null => {
    if (date === null || date === undefined) {
        return null;
    }
    const parsedDate = new Date(date);
    if (parsedDate instanceof Date && !isNaN(parsedDate.getTime())) {
        return parsedDate;
    }

    return null;
};

export function ageFromBirthday(birthday: Date): number {
    const today = new Date();
    let age = today.getFullYear() - birthday.getFullYear();
    const m = today.getMonth() - birthday.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birthday.getDate())) {
        age--;
    }
    return age;
}

export function dateToChatMessageTime(date: any): string {
    const newDate = new Date(date);


    // if date is today only return time in format "Today 7:00pm", if yesterday return "Yesterday 7:00pm" format else use date and time  12/12/2021 7:00pm
    const today = new Date();
    const yesterday = new Date();
    yesterday.setDate(today.getDate() - 1);
    if (newDate.getDate() === today.getDate() && newDate.getMonth() === today.getMonth() && newDate.getFullYear() === today.getFullYear()) {
        return `Today ${newDate.toLocaleTimeString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true })}`;
    }
    if (newDate.getDate() === yesterday.getDate() && newDate.getMonth() === yesterday.getMonth() && newDate.getFullYear() === yesterday.getFullYear()) {
        return `Yesterday ${newDate.toLocaleTimeString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true })}`;
    }
    return `${newDate.toLocaleDateString()} ${newDate.toLocaleTimeString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true })}`;

};

export function dateToShortReadable(date: any): string | null {
    if (!date) {
        return null;
    }
    const newDate = new Date(date)
    const options: Intl.DateTimeFormatOptions = {
        year: 'numeric', // Full year (e.g., "2024")
        month: 'numeric', // Full name of the month (e.g., "December")
        day: 'numeric'  // Day of the month (e.g., "3")
    };

    return newDate.toLocaleDateString(undefined, options);
}

// date to mm/dd/yyyy
export function dateToFormatString(date: any): string | null {
    if (!date) {
        return null;
    }
    const newDate = new Date(date)
    const month = String(newDate.getMonth() + 1).padStart(2, '0'); // Months are 0-based
    const day = String(newDate.getDate()).padStart(2, '0');
    const year = newDate.getFullYear();

    return `${month}/${day}/${year}`;
}